import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InventoryAlerts = ({ products }) => {
  if (!products || products?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-foreground">Inventory Alerts</h2>
          <Icon name="AlertTriangle" size={20} className="text-warning" />
        </div>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="CheckCircle" size={48} className="text-success mb-4" />
          <p className="text-muted-foreground">All products are well stocked</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-semibold text-foreground">Inventory Alerts</h2>
          <span className="px-2 py-1 bg-warning/20 text-warning text-xs font-semibold rounded-full">
            {products?.length}
          </span>
        </div>
        <Icon name="AlertTriangle" size={20} className="text-warning" />
      </div>
      
      <div className="space-y-3">
        {products?.map((product) => {
          const stockPercentage = (product?.stock_quantity / product?.low_stock_threshold) * 100;
          const isCritical = stockPercentage <= 50;
          
          return (
            <div
              key={product?.id}
              className={`p-4 rounded-lg border-l-4 ${
                isCritical ? 'border-error bg-error/5' : 'border-warning bg-warning/5'
              }`}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon
                      name={isCritical ? 'AlertCircle' : 'AlertTriangle'}
                      size={16}
                      className={isCritical ? 'text-error' : 'text-warning'}
                    />
                    <h3 className="text-sm font-semibold text-foreground">{product?.name}</h3>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">SKU: {product?.sku}</p>
                  <div className="flex items-center gap-4 text-xs">
                    <span className="text-muted-foreground">
                      Current: <span className="font-semibold text-foreground">{product?.stock_quantity}</span>
                    </span>
                    <span className="text-muted-foreground">
                      Threshold: <span className="font-semibold text-foreground">{product?.low_stock_threshold}</span>
                    </span>
                  </div>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  iconName="Plus"
                  onClick={() => alert('Restock functionality coming soon')}
                >
                  Restock
                </Button>
              </div>
              
              {/* Stock Level Bar */}
              <div className="w-full bg-accent/30 rounded-full h-2 mt-3">
                <div
                  className={`h-2 rounded-full transition-all ${
                    isCritical ? 'bg-error' : 'bg-warning'
                  }`}
                  style={{ width: `${Math.min(stockPercentage, 100)}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InventoryAlerts;